import http from '../../../Http';
import { useEffect, useState, useContext, useRef } from 'react';
import utils from '../../../utils';
import { Table, Input, DatePicker, Button, Tag } from 'antd';
import { LeftOutlined, RightOutlined, ReadOutlined  } from '@ant-design/icons';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const weatherCodeMap = {
    1000: "Clear, Sunny",      // 晴朗，阳光明媚
    1100: "Mostly Clear",      // 大部分晴朗
    1001: "Cloudy",            // 多云
    1101: "Partly Cloudy",     // 部分多云
    1102: "Mostly Cloudy",     // 大部分多云
    4000: "Drizzle",           // 毛毛雨
    4001: "Rain",              // 雨
    4200: "Light Rain",        // 小雨
    4201: "Heavy Rain",        // 大雨
};

function InverterWeatherHistoryList () {
    const { t } = useTranslation();
    const setTip = useContext(utils.tipContext);

    const [pageNo, setPageNo] = useState(0);
    const [pageSize, setPageSize] = useState(25);
    const [sn, setSn] = useState(null);
    const [date, setDate] = useState(moment());
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [rowTotal, setRowTotal] = useState(0);
    const [scrollY, setScrollY] = useState("");
    const [forceRefresh, setForceRefresh] = useState(0);

    const tip = "[InverterWeatherHistory]"


    function getTableScroll() {
        var th=  document.querySelectorAll("#table-inverter-weather-history .ant-table-thead")[0];
        let tHeaderBottom = 0
        if (th) {
            tHeaderBottom = th.getBoundingClientRect().top
        }
        let height = `calc(100vh - ${tHeaderBottom + 110}px)`
        return height
    }

    useEffect(() => {
        const scrollY = getTableScroll();
        setScrollY(scrollY);
        var tb =  document.querySelectorAll("#table-inverter-weather-history .ant-table-body")[0];
        tb.style.height = scrollY;
    }, [])

    useEffect(() => {
        if (!date) {
            return;
        }

        let active = true;

        (async () => {
            setLoading(true);
            
            let resp = await http.post("inverter-v2/inverters-applied-with-weather/list", { 
                PageNo: pageNo,
                PageSize: pageSize,
                InverterSN: sn ?? "",
                Date: date.format("YYYY-MM-DD"),
            }).then(async (r)=>{
                return await r.json();
            }).catch((e)=>{
                console.log(tip, e);
                return null;
            });

            if (! active) {
                return;
            }
            
            if (resp === null || resp.code !== 200) {
                setTip({open:true, severity:"error", msg:(resp && resp.msg) ? resp.msg : t("load data error")});
                
                setRowTotal(0)
                setRows([]);
        
                return;
            }

            setRowTotal(resp.data.RowTotal);
            setRows( resp.data.Rows);
            setLoading(false);
        })();

        return () => {
            active = false;
        };
    }, [pageNo, pageSize, sn, date, forceRefresh]);


    const handleSearch = (v, e) => {
        setPageNo(0);
        setSn(v ?? "");
        setForceRefresh(forceRefresh+1);
    }


    const items = [{
        title: "",
        width: 60,
        fixed: 'left',
        render: (v, r, idx) => {
            return (pageNo * pageSize + idx + 1);
        }
    }, {
        title: t('SN'),
        dataIndex: 'InverterSN',
        width: 180,
        fixed: 'left',
    }, {
        title: t('Date'),
        dataIndex: 'Date',
        width: 90,
    }, {
        title: t('Download Time'),
        dataIndex: 'SucessesesTime',
        width: 140,
        render: (v) => v??""
    }, {
        title: t('Weather'),
        dataIndex: 'WeatherCode',
        width: 120,
        render: (v, r, idx) => {
            if (v == undefined || v == null) {
                return ""
            } else if (weatherCodeMap[v]) {
                return t(weatherCodeMap[v]);
            }
            return t("Other");
        }
    }, {
        title: t('Charge Percent & Time'),
        dataIndex: 'SOC',
        width: 170,
        render: (v, r, idx) => {
            const es = [];
            if (v == undefined || v == null) {
                return ""
            } else {
                let st = r.STimeOfCharging.toString().padStart(4, "0");
                let et = r.ETimeOfCharging.toString().padStart(4, "0");
                st = st.substring(0, 2)+":"+st.substring(2, 4);
                et = et.substring(0, 2)+":"+et.substring(2, 4);
                return `${v}% [${st}-${et})`
            }
        }
    }, {
        title: t('Setting Result'),
        dataIndex: 'Successes',
        width: 110,
        render: (v, r, idx) => {
            return v == 7 ? <Tag color="green">{t("Success")}</Tag> : 
                v == 0 ? <Tag color="blue">{t("Pending")}</Tag> :
                v == -10 ? <Tag color="red">{t("Failed")}</Tag> :
                v == -11 ? <Tag color="red">{t("Weather server error")}</Tag> :
                <Tag color="#eeeeee">{t("Unknown")}</Tag>;
        }
    }]

    return (
        <div id="table-inverter-weather-history" style={{
            flex: "1 1 auto",
            display: "flex",
            flexDirection: "column",
            height: '100%',
        }}>
            <div style={{
                flex: '0 0 auto',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                paddingBottom: 8,
            }}>
                <div style={{
                    flex: "0 0 300px",
                    maxWidth: 400,
                }}>
                    <Button type="primary" icon={<LeftOutlined />} onClick={() => {setDate(date.clone().subtract(1, 'day'))}}/>
                    <DatePicker value={date} allowClear={false} onChange={(date) => {setDate(date)}}/>
                    <Button type="primary" icon={<RightOutlined />} onClick={() => {setDate(date.clone().add(1, 'day'))}}/>
                </div>
                <div style={{
                    flex: '1 1 auto',
                    display: "flex",
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                }}>
                    <Input.Search style={{width: 250}} placeholder={t("Enter Inverter SN")} onSearch={handleSearch} enterButton />
                </div>
            </div>
            <div style={{
                flex:"1 1 1px",
                position: "relative",
            }}>
                <div style={{display: "flex", flexDirection: "column", position: "absolute", height: '100%', width: "100%", overflow: "hidden"}}>
                    <Table 
                        columns={items}
                        pagination={{
                            pageSizeOptions: [25,50,100],
                            current: pageNo+1,
                            pageSize: pageSize,
                            total: rowTotal,
                            showSizeChanger: true,
                            showTotal: (total) => {return t("Total {{total}}", {total})},
                            onShowSizeChange: (current, size) => {
                                setPageSize(size);
                            },
                            onChange: (page, pageSize) => {
                                setPageNo(page-1);                                
                            }
                        }}
                        tableLayout="fixed"
                        bordered={true}
                        size="middle"
                        loading={loading}
                        rowKey="InverterSN"
                        dataSource={rows}
                        scroll={{ y: scrollY }}
                    />
                </div>
            </div>
        </div>
    );
}

export default InverterWeatherHistoryList;
